import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/callcenter',
    name: 'Call Center',
    component: () => import('../views/CallCenterView.vue')
  },
  {
    path: '/workView',
    name: 'Auftagsverwaltung - Arbeitsansicht',
    component: () => import('../views/contractManagement/WorkView.vue')
  },
  {
    path: '/job-money-transfer',
    name: 'ÜEB Aufträge - Arbeitsansicht',
    component: () => import('../views/contractManagement/JobMoneyTransfer.vue')
  },
  {
    path: '/job-money-transfer-cancelled',
    name: 'Ausgebuchte ÜEB Aufträge - Arbeitsansicht',
    component: () => import('../views/contractManagement/CancelledJobMoneyTransfer.vue')
  },
  {
    path: '/all-orders',
    name: 'Auftagsverwaltung - Alle',
    component: () => import('../views/contractManagement/AllView.vue')
  },
  {
    path: '/editContract/:id',
    name: 'Auftagsverwaltung - Auftrag bearbeiten',
    component: () => import('../views/contractManagement/EditJob.vue')
  },
  {
    path: '/cancelled-orders',
    name: 'Auftagsverwaltung - Storno',
    component: () => import('../views/contractManagement/CancelledView.vue')
  },
  {
    path: '/management/customer',
    name: 'Verwaltung - Kunden',
    component: () => import('../views/management/CustomerView.vue')
  },
  {
    path: '/management/employee',
    name: 'Verwaltung - Mitarbeiter',
    component: () => import('../views/management/MonteurView.vue')
  },
  {
    path: '/management/mediators',
    name: 'Verwaltung - Zentralen',
    component: () => import('../views/management/MediatorView.vue')
  },
  {
    path: '/management/debtCollectionEmployee',
    name: 'Verwaltung - Inkasso Mitarbeiter',
    component: () => import('../views/management/DebtCollectionEmployeeView.vue')
  },
  {
    path: '/management/contractTypes',
    name: 'Verwaltung - Einsatztypen',
    component: () => import('../views/management/ContractTypeView.vue')
  },
  {
    path: '/management/user',
    name: 'Verwaltung - Benutzer',
    component: () => import('../views/management/UserView.vue')
  },
  {
    path: '/management/templates',
    name: 'Verwaltung - Vorlagen',
    component: () => import('../views/management/TemplateKueView.vue')
  },
  {
    path: '/management/automaticAssumptionOfCosts',
    name: 'Verwaltung - Automatische Kostenübernahmen',
    component: () => import('../views/management/AutomaticAssumptionOfCostsView.vue')
  },
  {
    path: '/management/settings',
    name: 'Verwaltung - Einstellungen',
    component: () => import('../views/management/SettingsView.vue')
  },
  {
    path: '/management/employee/:id',
    name: 'Verwaltung - Mitarbeiter bearbeiten',
    component: () => import('../views/management/edit/MonteurEditView.vue')
  },
  {
    path: '/editInvoice/:id',
    name: 'Rechnung Bearbeiten',
    component: () => import('../views/invoices/EditInvoice.vue')
  },
  {
    path: '/editCrediting/:id',
    name: 'Gutschrift Bearbeiten',
    component: () => import('../views/invoices/EditCrediting.vue')
  },
  {
    path: '/editStorno/:id',
    name: 'Storno Bearbeiten',
    component: () => import('../views/invoices/EditStorno.vue')
  },
  {
    path: '/accounting',
    name: 'Buchhaltung',
    component: () => import('../views/accounting/AccountingView.vue')
  },
  {
    path: '/storage',
    name: 'Dateiablage',
    component: () => import('../views/storage/StorageView.vue')
  },
  {
    path: '/storage/file/:id',
    name: 'Datei anzeigen',
    component: () => import('../views/storage/StorageFileView.vue')
  },
  {
    path: '/showDocuments/:fileurl',
    name: 'Dokumente',
    component: () => import('../views/documents/DocumentView.vue')
  },
  {
    path: '/notifications',
    name: 'Benachrichtigungen',
    component: () => import('../views/Notifications.vue')
  },
  {
    path: '/logout',
    name: 'Abmelden',
    component: () => import('../views/user/Logout.vue')
  },
  {
    path: '/prod',
    name: 'Produktionsdatenbank',
    component: () => {
      import('../views/HomeView.vue')
      Vue.prototype.$prod = true;
    }
  },
  {
    // Geheimes Entwicklermenü - bewusst nicht in der Navigation verlinkt
    path: '/developer',
    name: 'Entwicklermenü',
    component: () => import('../views/developer/DeveloperView.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
